import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (project) =>
    present(
      repository
        .getProjectConfiguration(project)
        .then((config) => ({ project, config }))
        .catch(() => Promise.reject(project)),
    );
}

export type { Interactor };

export { createInteractor };
